import * as React from 'react';
import * as PropTypes from 'prop-types';
import Tooltip from 'components/Tooltip';
import classNames from 'classnames';
import { ReactTableDefaults } from 'react-table';

export function TdCustom({ style, className, tooltip, children }) {
  TdCustom.propTypes = {
    style: PropTypes.object,
    className: PropTypes.string,
    tooltip: PropTypes.bool,
    children: PropTypes.node,
  };
  return (
    <ReactTableDefaults.TdComponent
      className={classNames(className, 'ChecksTable__td')}
      style={style}
    >
      {children}

      {tooltip && (
        <Tooltip
          content={tooltip}
          fixed={true}
          isFormClass={false}
          hasWrapper={false}
          customIcon={'icon_info'}
        />
      )}
    </ReactTableDefaults.TdComponent>
  );
}
